class jMin {
	elements = []
	
	constructor(selector) {
		if (typeof selector === 'object') {
			this.elements = [selector];
		} else if (typeof selector === 'string') {
			let elems = document.querySelectorAll(selector);
			if (elems.length > 0) {
				this.elements = [...elems];
			}
		}
	}
	
	on(type, listener, options) {
		for(let el of this.elements) {
			el.addEventListener(type, listener, options);
		}
		return this;
	}

	hasClass(value) {
		let exists = false;
		for(let el of this.elements) {
			if (el.classList.contains(value)) return true;
		}
		return exists;
	}

	addClass(value) {
		for(let el of this.elements) {
			let classList = value.split(' ');
			for(className of classList) {
				el.classList.add(className);
			}
		}
		return this;
	}

	removeClass(value) {
		for(let el of this.elements) {
			let classList = value.split(' ');
			for(className of classList) {
				el.classList.remove(className);
			}
		}
		return this;
	}

	toggleClass(value) {
		for(let el of this.elements) {
			let classList = value.split(' ');
			for(className of classList) {
				el.classList.toggle(className);
			}
		}
		return this;
	}

	html(value) {
		if (value === undefined) {
			return this.elements[0].innerHTML;
		} else {
			for(let el of this.elements) el.innerHTML = value;
		}
	}

	val(value) {
		if (value === undefined) {
			return this.elements[0].value.trim();
		} else {
			for(let el of this.elements) el.value = value.trim();
		}
	}

	data(key, value) {
		if (value === undefined) {
			return this.elements[0].dataset[key];
		} else {
			this.elements[0].dataset[key] = value;
		}
	}

	not(value) {
		this.elements = this.elements.filter((element) => {
			return element !== value;
		});
		return this;
	}

	each(callback) {
		for(let el of this.elements) {
			callback(el);
		}
		return this;
	}

	find(selector) {
		let prevElements = this.elements;

		this.elements = [];
		for(let element of prevElements) {
			let elems = element.querySelectorAll(selector);
			if (elems.length > 0) {
				this.elements = [...this.elements, ...elems];
			}
		}
		return this;
	}

	children(selector) {
		let result = [], prevElements = this.elements;

		this.elements = [];
		for(let element of prevElements) {
			let elems = element.querySelectorAll(':scope > ' + selector);
			if (elems.length > 0) {
				this.elements = [...this.elements, ...elems];
			}
		}
		return this;
	}

	/*
	parents(selector) {
		this.elements[0].closest(selector)


		let result = [], prevElements = this.elements;

		this.elements = [];
		for(let element of prevElements) {
			let elems = element.querySelectorAll(':scope > ' + selector);
			if (elems.length > 0) {
				this.elements = [...this.elements, ...elems];
			}
		}
		return this;
	}*/

	event(event) {
		// Create our event (with options)
		let evt;

		if (event === 'click') {
			evt = new MouseEvent('click', {
				bubbles: true,
				cancelable: true,
				view: window
			});
		}

		for(let el of this.elements) {
			el.dispatchEvent(evt);
		}
	}

	empty() {
		return this.elements.length === 0;
	}

	all() {
		return this.elements;
	}
}

jmin = function (selector) {
	return new jMin(selector);
}

module.exports = jmin;